import { render, staticRenderFns } from "./addCommunity.vue?vue&type=template&id=0d594286&scoped=true&"
import script from "./addCommunity.vue?vue&type=script&lang=js&"
export * from "./addCommunity.vue?vue&type=script&lang=js&"
import style0 from "./addCommunity.vue?vue&type=style&index=0&id=0d594286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d594286",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d594286')) {
      api.createRecord('0d594286', component.options)
    } else {
      api.reload('0d594286', component.options)
    }
    module.hot.accept("./addCommunity.vue?vue&type=template&id=0d594286&scoped=true&", function () {
      api.rerender('0d594286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dynamic/communityDynamic/communityDynamicHome/components/addCommunity.vue"
export default component.exports